<template>
  <v-container class="py-8 samsung-gradient-bg" fluid>
    <v-row class="py-8">
      <v-col cols="12" class="py-8">
        <p class="white--text text-center">
          {{ $t(`${pageName}`) }}
        </p>
        <h1 class="text-center white--text" :class="$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2'">
          {{ $t(`${heroTitle}`) }}
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'heroHeader',
  props: {
    pageName: String,
    heroTitle: String,
  },
};
</script>

<style scoped>

</style>
